'use strict';

var Gender = function () {};

Gender.MALE = 'male';
Gender.FEMALE = 'female';

//export for node
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = Gender;
    }
    exports.Gender = Gender;
}